import React from "react";

const InstituteLeaveManagement = ({ PageName, IconName }) => {
  const Color = PageName === IconName ? "#4C34AD" : "#fff";

  return (
    <div className="ml-0 flex items-center gap-4">
      <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30">
        <path id="Icon_material-schedule" data-name="Icon material-schedule" d="M17.985,3A15,15,0,1,0,33,18,14.993,14.993,0,0,0,17.985,3ZM18,30A12,12,0,1,1,30,18,12,12,0,0,1,18,30Zm.75-19.5H16.5v9l7.875,4.725L25.5,22.38l-6.75-4.005Z" transform="translate(-3 -3)" fill="#fff"/>
      </svg>

      <p className="font-bold text-white">Leave Management</p>
    </div>
  );
};

export default InstituteLeaveManagement;
